import axios from 'axios';
import {message} from '@enos/dpl';
import _ from 'lodash';
import Error from '~/components/Modal/Error';
import SessionStore from '~/stores/SessionStore';
import {STATUS_CODE} from './constants';
import {ACCESS_TOKEN_SESSION_KEY, REDIRECT_TO_404, REDIRECT_TO_SELECT_COMPANY} from '~/utils/constants';
import sessionMessgaeModal from './sessionMessageModal';


const handleError = (response = {config: {}}) => {
  const {
    config: {showError = {}},
    data
  } = response;
  const {isShow, showPopup, title, onOk} = showError;
  if (isShow) {
    if (showPopup) {
      Error({
        title,
        content: data.message,
        onOk: () => {
          if (typeof onOk === 'function') {
            onOk();
          }
        }
      });
    } else {
      message.error(data.message || response.statusText);
    }
  }
  return Promise.reject(data);
};

const axiosInstance = axios.create({
  // 当创建实例的时候配置默认配置
  baseURL: '/app-portal/web/v1/',
  timeout: 1000 * 60 * 3,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 添加请求拦截器
axiosInstance.interceptors.request.use((config) => {
  const defaultShowError = {
    isShow: true,
    showPopup: false,
    title: ''
  };

  const instanceShowError = config.showError;

  config.showError = Object.assign(defaultShowError, instanceShowError);

  // accessToken
  const accessToken = SessionStore.tokenInCookie || localStorage.portalGetItem(ACCESS_TOKEN_SESSION_KEY);

  if (accessToken) {
    config.headers.common.Authorization = `Bearer ${accessToken}`;
  }

  // 为了兼容IE，统一为GET方法加上一个时间戳
  if (config.method === 'get') {
    if (!config.params) {
      config.params = {};
    }
    config.params.timestemp = new Date().getTime();
  }
  return config;
});

// 添加一个响应拦截器
axiosInstance.interceptors.response.use(
  (response) => {
    const {data} = response;

    // skip handler
    if (response.config.skipGlobalHandler && !data.code) {
      return Promise.resolve(data);
    }

    // 跳过没有相关权限的全局处理
    if (response.config.skipGlobalHandler && (data.code === STATUS_CODE.PERMISSION_DENIED || data.code === STATUS_CODE.NOT_FOUND)) {
      return Promise.resolve(data);
    }

    // 1.成功
    if (data.code === STATUS_CODE.SUCCESS || data.code === STATUS_CODE.SUCCESS_BUSINESS) {
      return Promise.resolve(data.data);
    }

    // 2. 用户不能同时登陆时
    if (data.code === STATUS_CODE.ALREADY_EXISTED) {
      return new Promise(() => {
        sessionMessgaeModal.show({sessionConflictMessage: data.message});
      });
    }

    // 3.session过期
    if (data.code === STATUS_CODE.UNAUTHENTICATED) {
      return new Promise(() => {
        sessionMessgaeModal.show({isSessionExpired: true});
      });
    }

    // 4. 未选择组织
    if (data.code === STATUS_CODE.ORGANIZATION_NOT_SELECTED) {
      window.eventTarget.dispatchEvent(REDIRECT_TO_SELECT_COMPANY);
      return Promise.reject(data);
    }
    // 5. 无相关权限
    if (!response.config.skipNotFound && (data.code === STATUS_CODE.PERMISSION_DENIED || data.code === STATUS_CODE.NOT_FOUND)) {
      window.eventTarget.dispatchEvent(REDIRECT_TO_404);
      return Promise.reject(data);
    }

    // 6.其他失败，比如校验不通过等
    return handleError(response);
  },
  // 6.系统错误，比如500、404等
  error => handleError(error.response)
);

// download file request
export const downloadFile = function(url, body = {}) {
  return axiosInstance.get(
    url,
    _.merge(
      {
        headers: {
          'content-type': 'application/form-data'
        },
        responseType: 'arraybuffer',
        skipGlobalHandler: true,
        transformResponse: [
          function(data) {
            try {
              return JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
            } catch (error) {
              return data;
            }
          }
        ]
      },
      body
    )
  );
};

//  download file request using post
export const downloadFileWithPost = function(url, body = {}) {
  return axiosInstance.post(
    url,
    body,
    {
      headers: {
        'content-type': 'application/json'
      },
      responseType: 'arraybuffer',
      skipGlobalHandler: true,
      transformResponse: [
        function(data) {
          try {
            return JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
          } catch (error) {
            return data;
          }
        }
      ]
    }
  );
};

export default axiosInstance;
